import * as Sentry from "@sentry/browser"
import type { BrowserOptions } from "@sentry/browser"

Sentry.init(<BrowserOptions>{
  dsn: useRuntimeConfig().public.sentryDsn,
  environment: process.env.NODE_ENV,
  enabled:
    process.env.NODE_ENV === "production" ||
    (process.env.NODE_ENV === "development" && process.env.SENTRY_DISABLED !== "true"),
  debug: process.env.NODE_ENV === "development" && process.env.SENTRY_DEBUG === "true",
  telemetry: {
    enabled: false
  },
  beforeSend(event) {
    if (process.env.NODE_ENV === "development") {
      console.error("Sentry would capture:", event)
      return null
    }
    return event
  }
})
